// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1GTLL","productName":"Table_productName__128lP"};